export type FinancialRouteLabelKey =
  | 'overview'
  | 'charges'
  | 'benefits'
  | 'invoices'
  | 'commissions'
  | 'commissionRules'
  | 'closures'
  | 'fiscalDocuments'

export type FinancialNavRoute = {
  href: string
  labelKey: FinancialRouteLabelKey
  matchNested?: boolean
}

export const FINANCIAL_NAV_ROUTES: FinancialNavRoute[] = [
  { href: '/financial/dashboard', labelKey: 'overview' },
  { href: '/financial/charges', labelKey: 'charges' },
  { href: '/financial/benefits', labelKey: 'benefits' },
  { href: '/financial/invoices', labelKey: 'invoices', matchNested: true },
  { href: '/financial/commissions', labelKey: 'commissions' },
  { href: '/financial/commission-rules', labelKey: 'commissionRules' },
  { href: '/financial/closures', labelKey: 'closures' },
  { href: '/financial/fiscal-documents', labelKey: 'fiscalDocuments' },
]

export function isFinancialSubRouteActive(pathname: string, href: string, matchNested?: boolean): boolean {
  if (href === '/financial/dashboard') {
    return pathname === '/financial/dashboard' || pathname === '/financial'
  }
  if (pathname === href) {
    return true
  }
  if (matchNested && pathname.startsWith(`${href}/`)) {
    return true
  }
  return false
}
